module.exports = __webpack_public_path__ + "img/1024.0b22885e.svg";